import { cn } from '@/lib/utils';

import { pillWidthClass } from '../dropdownStyles';
import { SubTab } from './data';

interface FocusedPillProps {
  tab: SubTab;
}

/**
 * The read-only pill that occupies the domain slot after a feature pill is
 * clicked. It mirrors the active-state styling of a selected `GenericSubTab`
 * (green border/text, optional hero) but is inert — navigation back/forward is
 * driven by the NavButtons, not by re-clicking this pill.
 */
export function FocusedPill({ tab }: FocusedPillProps) {
  return (
    <div
      className={cn(
        pillWidthClass,
        'self-stretch overflow-hidden rounded-md border border-[#107d40] bg-[#070909] px-4 text-sm text-[#107d40]',
        tab.hero
          ? 'flex items-center justify-between gap-3'
          : 'flex flex-col items-center justify-center text-center',
      )}
    >
      <div
        className={cn(
          'min-w-0 flex-1',
          tab.hero ? 'flex flex-col items-start' : 'flex flex-col items-center',
        )}
      >
        <span className="w-full truncate leading-tight">{tab.label}</span>
        {tab.subLabel && (
          <span className="mt-0.5 w-full truncate text-xs leading-tight opacity-80">
            {tab.subLabel}
          </span>
        )}
      </div>
      {tab.hero && (
        <div className="flex h-full w-14 flex-shrink-0 items-center justify-center">
          <img
            src={tab.hero}
            alt=""
            aria-hidden="true"
            className="h-full object-contain"
            style={
              tab.heroScale && tab.heroScale !== 1
                ? { transform: `scale(${tab.heroScale})` }
                : undefined
            }
          />
        </div>
      )}
    </div>
  );
}
